import Phaser from 'phaser'
import GameUtil from '../utils/game-util'

export default class Logo {
  /** @type Phaser.GameObjects.Image */
  Logo

  /**
   * @type {{
   * context: Phaser.Scene,
   * }}
   **/
  sceneContext = {}

  /**
   * @param {Phaser.Scene} context
   */
  constructor(context) {
    this.sceneContext = context
  }

  preload() {}

  create() {
    //logo
    let logoPosition = GameUtil.getViewPercentage(
      { X: this.sceneContext.isMobile ? 20 : 95, Y: 0 },
      this.sceneContext
    )
    this.Logo = this.sceneContext.add
      .image(logoPosition.X, 0, 'logo')
      .setOrigin(this.sceneContext.isMobile ? 0.5 : 1, 0)
      .setScale(1)
    GameUtil.resetSize(this.Logo)
  }
}
